module.exports = __webpack_public_path__ + "img/icon-out.c3ef7c5d.png";